import { getLocale } from '@libs/core';

export const INSIGHTS_INIT_PLACEHOLDER_APP_ID = 'placeholder-app-id';
export const INSIGHTS_INIT_PLACEHOLDER_SEARCH_KEY = 'placeholder-search-key';

function stripPublicKeysFromClientBundle(): boolean {
    return Boolean(process.env.NEXT_PUBLIC_EPHEMERAL?.trim()) || process.env.NODE_ENV === 'production';
}

function assertPublicEnv(
    name: 'NEXT_PUBLIC_ALGOLIA_APP_ID' | 'NEXT_PUBLIC_ALGOLIA_APP_SEARCH_KEY',
    value: string
): string {
    if (value) return value;

    if (process.env.NODE_ENV === 'development') {
        throw new Error(
            `[Algolia Insights] Missing ${name}. Run \`pnpm run env\` and select dev env for this app to run locally.`
        );
    }

    throw new Error(`[Algolia Insights] ${name} is not set (NODE_ENV=${process.env.NODE_ENV ?? 'unset'}).`);
}

export const getPublicAlgoliaInsightsAppId = (): string => {
    if (stripPublicKeysFromClientBundle()) return '';
    return assertPublicEnv('NEXT_PUBLIC_ALGOLIA_APP_ID', process.env.NEXT_PUBLIC_ALGOLIA_APP_ID?.trim() ?? '');
};

export const getPublicAlgoliaInsightsSearchKey = (): string => {
    if (stripPublicKeysFromClientBundle()) return '';
    return assertPublicEnv(
        'NEXT_PUBLIC_ALGOLIA_APP_SEARCH_KEY',
        process.env.NEXT_PUBLIC_ALGOLIA_APP_SEARCH_KEY?.trim() ?? ''
    );
};

export const getAlgoliaInsightsHost = (): string | undefined => {
    const locale = getLocale();
    const raw =
        locale === 'en-CA'
            ? process.env.NEXT_PUBLIC_ALGOLIA_INSIGHTS_HOST_URL_CA
            : process.env.NEXT_PUBLIC_ALGOLIA_INSIGHTS_HOST_URL;

    const host = raw?.trim();
    return host || undefined;
};

export const isAlgoliaInsightsConfigured = (): boolean =>
    Boolean(
        getAlgoliaInsightsHost() ||
            (process.env.NEXT_PUBLIC_ALGOLIA_APP_ID?.trim() && process.env.NEXT_PUBLIC_ALGOLIA_APP_SEARCH_KEY?.trim())
    );

export const getAlgoliaInsightsInitOptions = (): { appId: string; apiKey: string; host?: string } => {
    const host = getAlgoliaInsightsHost();

    return {
        appId: getPublicAlgoliaInsightsAppId() || INSIGHTS_INIT_PLACEHOLDER_APP_ID,
        apiKey: getPublicAlgoliaInsightsSearchKey() || INSIGHTS_INIT_PLACEHOLDER_SEARCH_KEY,
        ...(host ? { host } : {}),
    };
};
